import { Box, Text } from '@factorialco/deprecated-design-system'
import { useField } from 'formik'
import { Reorder } from 'framer-motion'
import type { ExportsExporterQuery } from 'generated/resources/graphql'
import { keyBy } from 'lodash'

import { FieldArray } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import AddButton from 'modules/universal_exports/components/ExportSidepanel/_Content/AddButton'
import { FormField } from 'modules/universal_exports/components/ExportSidepanel/types'

import FieldRow from './FieldRow'

type UniversalExportsExporterField =
  ExportsExporterQuery['universalExports']['exportersConnection']['nodes'][number]['fields'][number]

interface Props {
  exporterOptions: UniversalExportsExporterField[]
}

const Fields = ({ exporterOptions }: Props) => {
  const [_, { value: fields }, { setValue }] = useField<FormField[]>('fields')

  const optionsByName = keyBy(exporterOptions, 'name')

  const addableOptions = exporterOptions.filter(
    (option) => !fields.find((f) => f.name == option.name)
  )

  return (
    <Box flexDirection="column">
      {fields.length > 0 && (
        <Box flexDirection="row" width="full">
          <Box width="full" paddingLeft="s32">
            <Text.Normal weight="medium" size="200" color="textPrimary">
              {i18n.t('universal_exports.config.fields.column_data_v2')}
            </Text.Normal>
          </Box>
          <Box width="full" paddingLeft="s8" paddingRight="s24">
            <Text.Normal weight="medium" size="200" color="textPrimary">
              {i18n.t('universal_exports.config.fields.column_name_v2')}
            </Text.Normal>
          </Box>
        </Box>
      )}

      <FieldArray
        name="fields"
        render={(arrayHelpers) => (
          <Box gap="s16" key="fields">
            {fields.length > 0 && (
              <Reorder.Group axis="y" values={fields} onReorder={setValue}>
                {fields.map((field, index) => (
                  <Reorder.Item key={field.name} value={field} dragListener>
                    <FieldRow
                      name={`fields.${index}`}
                      defaultLabel={optionsByName[field.name]?.label}
                      options={addableOptions}
                      onDelete={() => arrayHelpers.remove(index)}
                    />
                  </Reorder.Item>
                ))}
              </Reorder.Group>
            )}
            <Box paddingLeft="s32">
              <AddButton
                multiple
                icon="add"
                options={addableOptions}
                onAdd={(field) => arrayHelpers.push({ name: field.name, label: field.label })}
              >
                {i18n.t('universal_exports.config.fields.add_column')}
              </AddButton>
            </Box>
          </Box>
        )}
      />
    </Box>
  )
}
export default Fields
